import CircleOvalFramingFormInputs from './CircleOvalFramingFormInputs'

export default CircleOvalFramingFormInputs
